import { fetchAPI } from "../../redux/api";
import { getTerminalId } from "../../Utills/terminalIdentity";

const read = async responsePromise => {
  const response = await responsePromise;
  if (response.ok) return response.status === 204 ? null : response.json();
  let message = "Device settings request failed.";
  try { const body = await response.json(); message = body.detail || body.message || body.title || message; } catch (_) {}
  throw new Error(message);
};

export const getDeviceSettings = () => read(fetchAPI(`device-settings?terminalKey=${encodeURIComponent(getTerminalId())}`));
export const saveTerminal = friendlyName => read(fetchAPI("device-settings/terminal", { terminalKey: getTerminalId(), friendlyName }, "PUT"));
export const saveNotificationSound = settings => read(fetchAPI("device-settings/terminal/notification-sound", {
  terminalKey: getTerminalId(),
  enabled: Boolean(settings.enabled),
  newOrderEnabled: Boolean(settings.newOrderEnabled),
  waiterRequestEnabled: Boolean(settings.waiterRequestEnabled),
  paymentEnabled: Boolean(settings.paymentEnabled),
}, "PUT"));
export const heartbeatTerminal = () => read(fetchAPI("device-settings/terminal/heartbeat", { terminalKey: getTerminalId() }, "POST"));
export const savePrinter = printer => read(fetchAPI("device-settings/printers", printer, "POST"));
export const savePrinterAssignments = (billPrinterProfileId, kotPrinterProfileId) => read(fetchAPI("device-settings/assignments", {
  terminalKey: getTerminalId(), billPrinterProfileId: billPrinterProfileId || null, kotPrinterProfileId: kotPrinterProfileId || null,
}, "PUT"));
export const createPrintJob = (documentType, documentId, idempotencyKey) => read(fetchAPI("device-settings/print-jobs", {
  terminalKey: getTerminalId(), documentType, documentId,
}, "POST", { idempotencyKey }));
export const updatePrintJob = (printJobId, status, error = null) => read(fetchAPI(`device-settings/print-jobs/${printJobId}`, { status, error }, "PATCH"));
export const retryPrintJob = (printJobId, reason) => read(fetchAPI(`device-settings/print-jobs/${printJobId}/retry`, { reason }, "POST"));
